export default __webpack_public_path__ + "img/bangkok_industry_mixer_2023-5c00cb9248f8f30aaf7a6d466e9e1bc0.png";